import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as ChevronRightIcon } from 'public/assets/icons/fi:chevron-right.svg'

interface Props {
  title: string
  description: string
  services: StrapiBlockComponent[]
}

function ServicePicker({ title, description, services }: Props) {
  return (
    <section className="font-heading text-blue-web-90">
      <div className="container | py-10 md:py-18">
        <h2
          className="text-3xl lg:text-5xl font-semibold | mb-7"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p className="font-body | text-xl | max-w-col-10 mb-8 md:mb-14">
          {description}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-16">
          {services.map(item => (
            <Link
              key={item.id}
              href={item.link?.href}
              target={item.link?.target}
              className="shadow-md hover:shadow-lg transition-all duration-200 ease-in | border border-gray-30 rounded-xl | max-w-col-4 p-6 md:px-6 md:py-8"
            >
              {item.multimedia?.media?.data?.attributes.url ? (
                <div className="mb-7 md:mb-8">
                  <Image
                    src={item.multimedia?.media?.data?.attributes.url}
                    alt={
                      item.multimedia?.media?.data?.attributes
                        .alternativeText ?? ''
                    }
                    width={item.multimedia?.media?.data?.attributes.width}
                    height={item.multimedia?.media?.data?.attributes.height}
                  />
                </div>
              ) : (
                <div className="h-12 mb-7 md:mb-8" />
              )}
              <div
                className="text-2xl font-semibold | mb-2"
                dangerouslySetInnerHTML={{ __html: item.title ?? '' }}
              />
              <div
                className="font-body | text-sm text-gray-60 | h-14 mb-8 md:mb-9"
                dangerouslySetInnerHTML={{ __html: item.description ?? '' }}
              />
              <div className="flex items-center | text-base text-blue-web-50 font-semibold">
                {item.link?.title}
                <div className="text-white bg-blue-web-50 | rounded-full | ml-2 p-1 md:p-2">
                  <ChevronRightIcon />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicePicker
